import { useState, useRef } from "react";
import {
  initialValuesDocumentosTecnicosModel,
  DocumentosTecnicosModel,
} from "../models/DocumentosModel/documentosTecnicos.model";
import documentosTecnicosServices from "../api/Documentos/documentosTecnicosServices";
import { useNavigate } from "react-router";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { saveFile } from "../utils/saveFile";
import DocumentosService from "../api/Documentos/api-documentos";
import { openNotification } from "../utils/Notifactions";
import { useEncrypt } from "./useEncrypt";

export const useFormDocumentacionTecnica = () => {
  // redux
  const { decrypt } = useEncrypt();
  const idConvocatoria = decrypt(localStorage.getItem("id_convocatoria"));
  // state
  const [documento, setDocumento] = useState<DocumentosTecnicosModel>(
    initialValuesDocumentosTecnicosModel
  );
  const [documentos, setDocumentos] = useState<DocumentosTecnicosModel[]>([]);
  const [modalVisualizarDocumento, setModalVisualizarDocumento] =
    useState(false);
  const [documentoVisulizar, setDocumentoVisulizar] = useState("");
  const [modalEditarDocumento, setModalEditarDocumento] = useState(false);
  const [indexDocumento, setIndexDocumento] = useState(0);
  const [guardoArchivo, setGuardoArchivo] = useState(false);
  const [modaleliminar, setModaleliminar] = useState<boolean>(false);
  const [indexDocumentacion, setIndexDocumentacion] = useState<number>(0);
  const [nombreDocumento, setNombreDocumento] = useState<string>("");
  const [loading, setLoading] = useState(false);

  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const guardarArchivo = async (e: any) => {
    let type = e.target.files[0].type;

    if (e.target.files[0].size > 5000000) {
      return openNotification({
        titulo: "Error",
        descripcion: "Solo se permiten archivos menores a 5MB",
        placement: "bottomRight",
      });
    }

    if (e.target.files.length > 0) {
      const data = await saveFile(e);
      
      if (
        type === "application/pdf" ||
        type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        type ===
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        type === "image/png" ||
        type === "image/jpeg"
      ) {
        setGuardoArchivo(true);

        return setDocumento({ ...documento, url_documento: data.data });
      }
    }
  };

  const agregarfila = () => {
    if (Array.isArray(documentos)) {
      setGuardoArchivo(false);
      setDocumentos([...documentos, documento]);
    } else {
      setDocumentos([documento]);
    }

    return setDocumento(initialValuesDocumentosTecnicosModel);
  };
  const eliminarFila = async (index: number) => {
    let infoupdate = [...documentos];
    setModaleliminar(false);
    if (infoupdate[index].url_documento) {
      await DocumentosService.eliminarArchivo(infoupdate[index].url_documento);
    }
    infoupdate = infoupdate.filter((data: any, i: number) => i !== index);
    infoupdate = infoupdate.map((data: any, i: number) => {
      return {
        ...data,
        index: i,
      };
    });
    return setDocumentos(infoupdate);
  };
  const guardarycontinuar = async () => {
    setLoading(true);
    await documentosTecnicosServices.postDocumentosTecnicos(
      idConvocatoria,
      documentos
    );
    setLoading(false);
    navigate("/administrador/documentacionConvocatoria");
  };
  const editarFila = () => {
    let infoupdate = [...documentos];
    infoupdate[indexDocumento] = documento;
    return setDocumentos(infoupdate);
  };
  const cargarDocumentosTecnicos = async () => {
    let { data } = await apiConvocatorias.getConvocatoriaById(idConvocatoria);
    if (data.documentos_tecnicos === null) data.documentos_tecnicos = [];
    return setDocumentos(data.documentos_tecnicos);
  };
  return {
    cargarDocumentosTecnicos,
    documento,
    setDocumento,
    documentos,
    setDocumentos,
    fileInputRef,
    guardarArchivo,
    agregarfila,
    editarFila,
    eliminarFila,
    guardarycontinuar,
    modalvisualizardocumento: modalVisualizarDocumento,
    setModalVisualizarDocumento,
    documentovisualizar: documentoVisulizar,
    setDocumentoVisulizar,
    modaleditardocumento: modalEditarDocumento,
    setModalEditarDocumento,
    setIndexDocumento,
    indexdocumento: indexDocumento,
    guardoArchivo,
    setGuardoArchivo,
    modaleliminar,
    setModaleliminar,
    indexDocumentacion,
    setIndexDocumentacion,
    nombreDocumento,
    setNombreDocumento,
    loading,
  };
};
